module.exports = __webpack_public_path__ + "img/benefit-schedule.be578e7c.svg";